export default "__VITE_ASSET__CF9jIJ_q__"